<div #vegaVis>
  Vega Visualization Entry Point
</div>



// WEBPACK FOOTER //
// ./src/app/hsd-tree/sum-tree/sum-tree.component.html